import JwtBaseClient from './JwtBaseClient';

/**
 * @class RetailApiClient
 * @description API wrapper for the Retail API (ACV MAX retail price estimate)
 */
class RetailApiClient extends JwtBaseClient {
  constructor() {
    super(
      `${import.meta.env.VITE_RETAIL_API_BASE_URI}`,
      'response.data.error',
    );
  }

  /**
   * @function fetchRetailPrice
   * @description Fetch ACV MAX Retail estimate for a vehicle
   * @param {Object} payload
   * @param {string} payload.vin
   * @param {number} payload.odometer
   * @param {string} payload.zip
   * @param {Object|null} [cancelToken=null] - Optional cancel token
   * @returns {Promise<Object|null>} estimate in the shape the badge expects:
   *   { title, information_message, price, min_price, max_price }
   *   or null when there is no retail price for the given VIN.
   */
  fetchRetailPrice({ vin, odometer, zip }, cancelToken = null) {
    return this.post('get_estimate', { vin, odometer, zip }, null, cancelToken)
      .then((response) => {
        const data = response?.data;
        if (data?.response_status !== 'success') return null;
        return {
          title: 'ACV MAX Retail',
          information_message: 'ACV Estimate represents what we think this vehicle will sell for based on a variety of data points including vehicle condition, location, and more',
          price: data.acv_estimate,
          min_price: data.low_value,
          max_price: data.high_value,
        };
      })
      .catch((error) => {
        if (error?.response?.status === 422) return null;
        throw error;
      });
  }
}

export default RetailApiClient;
